import React, { useLayoutEffect, useRef, useState } from "react";
import { createBrowserRouter, RouterProvider, useRouteError } from "react-router-dom";

// The data router's own default error page prints the raw error and stack in
// English. Rethrowing hands a shell crash to the app's ErrorBoundary around this
// router (translated fallback, stale-chunk reload), as under BrowserRouter.
function RethrowRouteError(): never {
  throw useRouteError();
}

// One root route preserves the existing descendant route tables. Data-router
// history enables useBlocker for sidebar, link, replace and Back/Forward moves.
// Construct in the effect so StrictMode disposes its first history listener; a
// layout effect, so the router exists before the first paint and no placeholder
// frame is ever shown.
export function TenantNavigationRouter({ children }: { children: React.ReactNode }): React.ReactElement | null {
  const initial = useRef(children);
  const [router, setRouter] = useState<ReturnType<typeof createBrowserRouter> | null>(null);
  useLayoutEffect(() => {
    const next = createBrowserRouter([{ path: "*", element: initial.current, errorElement: <RethrowRouteError /> }], { future: { v7_relativeSplatPath: true } });
    setRouter(next);
    return () => next.dispose();
  }, []);
  return router ? <RouterProvider router={router} future={{ v7_startTransition: true }} /> : null;
}
